import { inject, Injectable } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { WebSocketService } from '@services/web-socket.service';
import { TopicType } from '../enums/topic-type';
import { DataArgument } from '@interfaces/data/data-argument';
import { DataStore } from '@stores/data.store';
import { MessageDataResponse } from '@interfaces/data/message-data-response';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private dataStore = inject(DataStore);
  private authService = inject(AuthService);
  private webSocketService = inject(WebSocketService);
  private uuid = this.webSocketService.uuid;
  locale = this.dataStore.locale;

  setData(res: MessageDataResponse) {
    const locale = res?.data?.config?.locale;
    if (res?.status && res?.key === this.uuid) {
      if (locale) {
        this.dataStore.setData({ locale });
      }
    }
  }

  sendDataRequest(args: DataArgument[]) {
    const userId = this.authService.user()?.id;
    const message: object = {
      requester: userId,
      parameters: args,
    };
    this.webSocketService.send({ topic: TopicType.DATA_REQUEST, message });
  }

  sendDataConfigRequest(args: DataArgument[]) {
    const userId = '@u:system';
    const message: object = {
      requester: userId,
      parameters: args,
    };
    this.webSocketService.send({ topic: TopicType.DATA_REQUEST, message });
  }
}
